var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card', _vm._b({
    attrs: {
      "outlined": "",
      "tile": ""
    }
  }, 'v-card', {
    width: _vm.width,
    loading: _vm.loading
  }, false), [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('canvas', _vm._g(_vm._b({
    ref: "canvas"
  }, 'canvas', {
    width: _vm.width,
    height: _vm.height
  }, false), {
    mousedown: _vm.mousedown,
    mousemove: _vm.mousemove,
    mouseup: _vm.mouseup,
    touchstart: _vm.touchstart,
    touchmove: _vm.touchmove,
    touchend: _vm.touchend
  }))]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-divider')], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "block": "",
      "tile": ""
    },
    on: {
      "click": function ($event) {
        (_vm.$emit('sync') || true) && _vm.sync();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(" mdi-refresh ")]), _c('span', {
    staticClass: "px-4"
  }, [_vm._v(" 초기화 ")])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "block": "",
      "tile": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.init
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(" mdi-eraser ")]), _c('span', {
    staticClass: "px-4"
  }, [_vm._v(" 다시그리기 ")])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-file-btn', {
    attrs: {
      "small": "",
      "text": "",
      "block": "",
      "tile": "",
      "color": "secondary"
    },
    on: {
      "input": _vm.emitFile
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(" mdi-file-image ")]), _c('span', {
    staticClass: "px-4"
  }, [_vm._v(" 파일업로드 ")])], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }